export const facturaMotoForm = {
    isValid: false,
    values: {
        cvetda: "1",
        oprcaj: "",
        fechaCompra: new Date(),
        importe: ""
    },
    touched: {
        cvetda: false,
        oprcaj: false,
        fechaCompra: false,
        importe: false,
    },
    errors: {}
};

export const facturaMotoConstraints = {
    cvetda: {
        presence: {
            allowEmpty: false,
            message: '^La clave de la tienda es requerida.'
        }
    },
    oprcaj: {
        presence: {
            allowEmpty: false,
            message: '^La operación de caja es requerida.'
        }
    },
    fechaCompra: {
        presence: {
            allowEmpty: false,
            message: '^La fecha de compra es requerida.'
        }
    },
    importe: {
        presence: {
            allowEmpty: false,
            message: '^El importe es requerido.'
        }
    },
};